import { IconPencilPlus } from "@tabler/icons-react";
import {
  Drawer,
  Descriptions,
  Tag,
  Button,
  Flex,
  Space,
  List,
  Popover,
  Badge,
} from "antd";
import React, { useState } from "react";
import CustomModal from "../../components/modal/CustomModal";
import { useToast } from "../../components/toast/toast";
import api from "../../api";
import CustomTextarea from "../../components/input/CustomTextarea";
import CustomSelect from "../../components/select/CustomSelect";
import { useAuth } from "../../store/context/AuthContext";

const renderStatusTag = (status) => {
  switch (status) {
    case "canceled" || "failed":
      return <Tag color="red">Цуцлагдсан</Tag>;
    case "paid":
      return <Tag color="blue">Төлсөн</Tag>;
    case "pending":
      return <Tag color="orange">Хүлээгдэж байна</Tag>;
    default:
      return <Tag color="default">{status}</Tag>;
  }
};

const renderSmsTag = (status) => {
  if (status === "sent") return <Tag color="green">Явсан</Tag>;
  if (status === "failed") return <Tag color="red">Амжилтгүй</Tag>;
  if (status === "pending") return <Tag color="orange">Хүлээгдэж байна</Tag>;
  return <Tag color="default">{status}</Tag>;
};

const renderComplaintStatusTag = (s) => {
  if (s === "resolved") return <Tag color="green">Шийдсэн</Tag>;
  if (s === "rejected") return <Tag color="red">Татгалзсан</Tag>;
  return <Tag color="orange">Хүлээгдэж байна</Tag>;
};

const TicketDetailDrawer = ({ open, onClose, record }) => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    user_request: "",
    type: "TICKET",
  });
  const toast = useToast();
  const { reference } = useAuth();

  // console.log("record --->", record);

  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const clearHandler = () => {
    setShowModal(false);
    setFormData({
      title: "",
      description: "",
      user_request: "",
      type: "TICKET",
    });
  };

  const submitHandler = async () => {
    // console.log("submitHandler record --->", record);
    // console.log({
    //   ...formData,
    //   ticket_prefix: record.Lottery?.ticket_prefix || "",
    //   ticket_id: record.id || "",
    //   invoice_id: record.invoice_id || "",
    //   lottery_id: record.lottery_id || "",
    //   payment_id: record.Payments?.[0]?.id || "",
    // });
    const payload = {
      ...formData,
      phone: record.phone_number || "",

      ticket_prefix: record.Lottery?.ticket_prefix || "",
      ticket_id: record.id || "",
      invoice_id: record.invoice_id || "",
      lottery: record.Lottery || "",
      // lottery_id: record.lottery_id || "",
      payment_id: record.Payments?.[0]?.id || "",
      lottery_numbers: record.LotteryNumbers.map((e) => e.number) || "",
    };
    if (payload.title && payload.description && payload.user_request) {
      setLoading(true);
      const res = await api.create_complaint(payload);
      // console.log("create complaint res --->", res);

      if (res.status === 201) {
        clearHandler();
        toast("Амжилттай үүслээ.", "success");
      } else {
        toast(res.data.message || "Алдаа гарлаа", "error");
      }
      setLoading(false);
    }
  };

  // Complaints summary (record.ComplaintsInfo-г BE нь буулгаж өгдөг)
  const complaintsInfo = record?.ComplaintsInfo || {};
  const complaintItems = complaintsInfo.items || [];
  const complaintsCount = complaintsInfo.count || 0;

  // Popover content (hover үед харагдах хэсэг)
  const complaintPopoverContent = (
    <div style={{ maxWidth: 520 }}>
      {complaintItems.length ? (
        <List
          size="small"
          dataSource={complaintItems}
          renderItem={(c) => (
            <List.Item key={c.id} style={{ alignItems: "flex-start" }}>
              <Space direction="vertical" size={2} style={{ width: "100%" }}>
                <Flex vertical>
                  <p style={{ fontSize: 12, color: "#333" }}>
                    Төлөв: {renderComplaintStatusTag(c.status)}
                  </p>
                  <p style={{ fontSize: 12, color: "#333" }}>
                    Гарчиг:{" "}
                    <span style={{ fontWeight: 500, color: "#000" }}>
                      {reference.find((e) => e.reference_key === c?.title)
                        ?.name || ""}
                    </span>
                  </p>
                  <p style={{ fontSize: 12, color: "#333" }}>
                    Дэлгэрэнгүй:{" "}
                    <span style={{ fontWeight: 500, color: "#000" }}>
                      {c.description || "-"}
                    </span>
                  </p>
                  {c.user_request && (
                    <p style={{ fontSize: 12, color: "#333" }}>
                      Хэрэглэгчийн хүсэлт:{" "}
                      <span style={{ fontWeight: 500, color: "#000" }}>
                        {reference.find(
                          (e) => e.reference_key === c?.user_request
                        )?.name || ""}
                      </span>
                    </p>
                  )}
                  {c.comment && <Tag color="default">Тайлбар: {c.comment}</Tag>}
                  <p style={{ fontSize: 12, color: "#333" }}>
                    Үүсгэсэн огноо:{" "}
                    <span style={{ fontWeight: 500, color: "#000" }}>
                      {new Date(c.created_at).toLocaleString()}
                    </span>
                  </p>
                  {(c.created_by_name || c.created_by_id) && (
                    <p style={{ fontSize: 12, color: "#333" }}>
                      Үүсгэсэн ажилтан:{" "}
                      <span style={{ fontWeight: 500, color: "#000" }}>
                        {c.created_by_name || c.created_by_id}
                      </span>
                    </p>
                  )}
                </Flex>
              </Space>
            </List.Item>
          )}
        />
      ) : (
        <p style={{ fontSize: 12, color: "#333" }}>Гомдол олдсонгүй</p>
      )}
    </div>
  );

  if (!record) return null;

  const payment = record.Payments?.[0];

  return (
    <>
      <Drawer
        title="Сугалааны дэлгэрэнгүй"
        placement="right"
        onClose={onClose}
        open={open}
        width={800}
      >
        <Flex vertical gap={"20px"}>
          <Flex align="center" justify="space-between" gap={"10px"}>
            <Descriptions column={1} size="small" bordered>
              {/* ...таны өөр Descriptions.Item-ууд ... */}

              <Descriptions.Item label="Гомдол">
                {/* Хэдэн гомдол байгааг badge-тай tag-аар харуулна */}
                <Popover
                  content={complaintPopoverContent}
                  title={
                    <Space align="center">
                      <p strong>Гомдлын жагсаалт</p>
                      <Tag color="orange">Нийт: {complaintsCount}</Tag>
                    </Space>
                  }
                  trigger="hover"
                  placement="topLeft"
                >
                  <Badge count={complaintsCount} color="#faad14">
                    <Tag
                      color={complaintsCount ? "orange" : "default"}
                      style={{ cursor: "pointer" }}
                    >
                      {complaintsCount ? "Гомдол харах" : "Гомдол байхгүй"}
                    </Tag>
                  </Badge>
                </Popover>
              </Descriptions.Item>
            </Descriptions>
            <Button
              variant="dashed"
              color="danger"
              // size="large"
              style={{
                padding: "0px 20px",
                width: "fit-content",
                // alignSelf: "flex-end",
              }}
              onClick={() => setShowModal(true)}
            >
              <IconPencilPlus size={16} />
              Гомдол үүсгэх
            </Button>
          </Flex>

          <Descriptions column={1} size="small" bordered>
            <Descriptions.Item label="Сугалааны нэр">
              {record.Lottery?.title || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Сугалааны код">
              {record.Lottery?.ticket_prefix || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Утасны дугаар">
              {record.phone_number}
            </Descriptions.Item>
            <Descriptions.Item label="Төлөв">
              {renderStatusTag(record.status || "Тодорхойгүй")}
            </Descriptions.Item>
            {record.canceled_comment && (
              <Descriptions.Item
                label={
                  record?.status == "paid" ? "Тайлбар" : "Цуцалсан тайлбар"
                }
              >
                {record.canceled_comment}
              </Descriptions.Item>
            )}
            <Descriptions.Item label="Үнэ">
              {payment?.amount || "0"}₮
            </Descriptions.Item>
            <Descriptions.Item label="Төлбөрийн арга">
              {payment?.method?.toUpperCase() || "-"}
            </Descriptions.Item>
            {record?.BankInfo?.account && (
              <Descriptions.Item label="Дансны дугаар">
                {record?.BankInfo?.account}
              </Descriptions.Item>
            )}
            <Descriptions.Item label="Төлбөрийн төлөв">
              {renderStatusTag(payment?.status || "Тодорхойгүй")}
            </Descriptions.Item>
            {payment?.method === "manual" && (
              <Descriptions.Item label="Сугалаа өгсөн админ">
                {payment?.meta?.assigned_by || "-"}
              </Descriptions.Item>
            )}
            <Descriptions.Item label="Төлсөн огноо">
              {payment?.paid_at
                ? new Date(payment.paid_at).toLocaleString()
                : "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Бүртгэгдсэн">
              {new Date(record.created_at).toLocaleString()}
            </Descriptions.Item>
          </Descriptions>

          <Descriptions column={1} size="small" bordered>
            <Descriptions.Item label="Сугалааны дугаар">
              {record.LotteryNumbers?.length
                ? record.LotteryNumbers.map((e) => {
                    const short =
                      typeof e.number === "string"
                        ? e.number.replace(/^[^-]*-/, "")
                        : e.number;
                    return (
                      <Tag key={e.id} color="blue">
                        {/* {e.number} */}
                        {short}
                      </Tag>
                    );
                  })
                : "-"}
            </Descriptions.Item>
            {/* <Descriptions.Item label="дугаар">
              {record?.match_code || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Хэдэн орон таарсан">
              {record?.match_length || "-"}
            </Descriptions.Item> */}
            {/* <Descriptions.Item label="Гарсан сугалааны дугаар">
              {record?.win_number || "-"}
            </Descriptions.Item> */}
          </Descriptions>

          <Descriptions column={1} size="small" bordered>
            <Descriptions.Item label="Мессеж төлөв">
              {renderSmsTag(record?.SmsInfo?.status || "Илгээгээгүй")}
            </Descriptions.Item>
            {record?.SmsInfo?.message && (
              <Descriptions.Item label="Мессеж">
                {record?.SmsInfo?.message || "-"}
              </Descriptions.Item>
            )}
          </Descriptions>
        </Flex>
      </Drawer>

      <CustomModal
        title={"Гомдол үүсгэх"}
        width={450}
        open={showModal}
        onOk={submitHandler}
        onCancel={() => clearHandler()}
        disabled={
          !formData.title || !formData.description || !formData.user_request
        }
      >
        <Flex vertical gap={"10px"}>
          <CustomSelect
            required
            title={"Гарчиг"}
            options={reference
              .filter((e) => e.type === "complain_type")
              .map((e) => {
                return {
                  label: e.name,
                  value: e.reference_key,
                };
              })}
            value={formData.title}
            onChange={(e) => handleChange("title", e)}
            disabled={reference.length === 0}
          />

          <CustomTextarea
            required
            title={"Дэлгэрэнгүй"}
            value={formData.description}
            onChange={(e) => handleChange("description", e.target.value)}
            maxLength={200}
          />

          <CustomSelect
            required
            title={"Хэрэглэгчийн хүсэлт"}
            options={reference
              .filter((e) => e.type === "complaint_user_request")
              .map((e) => {
                return {
                  label: e.name,
                  value: e.reference_key,
                };
              })}
            value={formData.user_request}
            onChange={(e) => handleChange("user_request", e)}
            disabled={reference.length === 0}
          />
        </Flex>
      </CustomModal>
    </>
  );
};

export default TicketDetailDrawer;
